export default __webpack_public_path__ + "static/bc_en_6-2df0eb5cab25b193d488510249c8e8b5.mp4";